import { Link, useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import Header from "../../components/partials/Header";
import Footer from "../../components/partials/Footer";



const Home = () => {
    const navigate = useNavigate(); // Initialize the navigate function

    return (
        <>
            <div id="hero">
                <Header page={'home'} />

                <div className="hero_wrapper">
                    <div className="hero_content">
                        <img src="/images/hero1.png" alt="" />
                        <img src="/images/hero2.png" alt="" />
                        <img src="/images/certs.png" alt="" />
                    </div>
                </div>
            </div>
            <div className="home_catalog">
                <div className="hc_title">
                    <h2>კატალოგი</h2>
                </div>

                <div className="hc_wrapper">
                    <div className="hc_item">
                        <img src="/images/hci_1.png" alt="" />
                    </div>
                    <div className="hc_item">
                        <img src="/images/hci_2.png" alt="" />
                    </div>
                    <div className="hc_item">
                        <img src="/images/hci_3.png" alt="" />
                    </div>
                    <div className="hc_item">
                        <img src="/images/hci_4.png" alt="" />
                    </div>
                    <div className="hc_item">
                        <img src="/images/hci_5.png" alt="" />
                    </div>
                    <div className="hc_item hc_link">
                        <img src="/images/hci_6.png" alt="" />
                        <div className="hcl_info">
                            <p>სრული კატალოგი</p>
                            <Link to={'/catalog'}>მეტის ნახვა</Link>
                        </div>
                    </div>
                    {/* <div className="hc_item hc_link">
                        <p>სრული კატალოგი</p>
                        <Link to={'/catalog'}>ნახვა</Link>
                    </div> */}
                </div>
            </div>
            <div className="home_about">
                <div className="ha_title hc_title">
                    <h2>ჩვენ შესახებ</h2>
                </div>
                <div className="ha_wrapper">
                    <div className="ha_info">
                        <p>
                            Sky hook Georgia უკვე წლებია რაც წარმატებით ოპერირებს ქართულ ბაზარზე და მომხმარებელს სთავაზობს უსაფრთხო მშენებლობისთვის საჭირო სხვადასხვა ლითონის კონსტრუქციებს: 
                        </p>
                        <ul>
                            <li className="fw-900">საყალიბე სისტემები</li>
                            <li className="fw-900">შიდა და საფასადე, გარე ხარაჩოები</li>
                            <li className="fw-900">მიმღები ბაქნები</li>
                            <li className="fw-900">შახტაში ასაწყობი ხარაჩოები</li>
                            <li className="fw-900">უსაფრთხოების რეგულირებად & ფიქსირებულ მოაჯირები</li>
                            <li className="fw-900">ნებისმიერი ტიპის მეტალის კონსტრუქციები (კარი, ჭიშკარი და სხვა)</li>
                        </ul>
                        <p> 
                            ლითონ კონსტრუქცია <span className="fw-900">დამზადებულია საქართველოში და აკმაყოფილებს ყველა სახელმწიფო  და ევრო სტანდარტს</span> ხარაჩოების და ყალიბების წარმოებისთვის, რეალიზაციისა და ექსპორტისთვის. 
                            №477 27.10.2017
                            №361 27.05.2014
                        </p>
                    </div>
                    <div className="ha_cers">
                        <img src="/images/certs.png" alt="" />
                    </div>
                </div>
            </div>

            <Footer />

        </>
    )
}
  
export default Home